import React from 'react';
import { getConfiguration } from '../../data/utils';

export default function Results(props) {
    const conf = getConfiguration();
    const src = conf.ps?.rst;

    return (
        <iframe title="xs-results-iframe" src={src} className="c_34" rounded="true" />
    );
}
